export function roundPrice(value) {
  return Math.round(value * 100) / 100
}

export function roundPriceNoDecimals(value) {
  return Math.floor(value)
}

export function orderStatusText(status) {
  const statuses = {
    1: 'nová',
    2: 'vybavená',
  }
  return statuses[status]
}
